module.exports = __webpack_public_path__ + "static/pr-detail2-9089c86bc5089300fdd84f4ce58efe50.png";